import Vue from 'vue';
let router;
let Event = new Vue();
import store from '../store'
import { configEnv } from '../config/config' 

Event.$on('logOut', () => {
  localStorage.removeItem(configEnv.userDataKey);
  localStorage.removeItem(configEnv.tokenKey);
  store.commit('logOut')
  router.push('/login');
});

const setRouter = (routerModule) => {
  router = routerModule;
};

export const EventDriver = Event;
export const useRouterForEventDriver = setRouter;